module.exports = __webpack_public_path__ + "static/media/email.ef40d2d5.svg";